import gql from 'graphql-tag';

const NAME = 'moveIqEstimate';
const FRAGMENT = `fragment ${NAME} on MoveIqEstimate {
  companyId
  status
  batchId
}`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
